import type { PriceGridFilterState } from './types';

export function getIsBBOEnabled(filterState: PriceGridFilterState) {
  return filterState.custom?.enableBBO !== false;
}

export function setIsBBOEnabled(filterState: PriceGridFilterState, enabled: boolean) {
  return {
    ...filterState,
    custom: {
      ...filterState.custom,
      enableBBO: enabled ? undefined : false,
    },
  };
}
